/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict'; 
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + formatPrice(price) + '</b>';
    if (comparing) {
      res =
        '<s class="is-size-6 is-bold has-text-textone">' +
        formatPrice(compare_at_price) +
        '</s><br>' + res;
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b><span>from</span><br>' + formatPrice(min) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b><span>from</span><br>' + formatPrice(min) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle () {
      var res = null;
      if (this.meta.Mandatory != undefined) {
        if (this.meta.Mandatory.Unique_Website_Name != undefined) {
          var res = this.meta.Mandatory.Unique_Website_Name;
        } 
      } else {
        var res = this._highlightResult.title.value;
        if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
          res += '<span class="algolia-variant">(' + this._highlightResult.variant_title.value + ')</span>';
        }
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + this.variant_title.value + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    // Product Promotions
    promotion: function promotion () {
      var promotion = null;
      if (this.meta.Promotions != undefined) {
        if (this.meta.Promotions.Promotions_Colour != undefined) {
          var color = this.meta.Promotions.Promotions_Colour.toLowerCase();
        } else {
          var color = 'primary';
        }
        if (this.meta.Promotions.Promotions_Product_Level) {
          promotion = '<div class="product-promo collection-level is-'+color+'">' + this.meta.Promotions.Promotions_Product_Level + '</div>';
        } 
      }
      return promotion;
    },
    // Product Badge
    badge: function badge () {
      var badge = null;
      if (this.meta.Badges != undefined) {
        if (this.meta.Badges.Product_Badges) {
          badge = '<span class="product__badge has-background-primarydark islet"><span class="has-text-white is-bold">' + this.meta.Badges.Product_Badges + '</span></span>';
        } 
      }
      return badge;
    },
    // Product Badge Bottom
    badgeBottom: function badgeBottom () {
      var badgeBottom = null;
      if (this.meta.Badges != undefined) {
        if (this.meta.Badges.Image_Overlay_Bottom) {
          try {
            if (this.meta.Badges.Image_Overlay_Bottom) {
              var str = this.meta.Badges.Image_Overlay_Bottom.replace(/\s+/g, '-').toLowerCase();
              var imgSrc = 'https://cdn.shopify.com/s/files/1/0015/0778/6797/files/' + str + '.png';
              var imgBottom = '<img src="'+imgSrc+'" style="max-width: 80px;" onError="style.display = \'none\';">'
              if (imgSrc != '//cdn.shopify.com/s/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_100x.gif') {
               var badgeBottom = '<span class="product__badge_image">' + imgBottom + '</span>';
              }
            }
          } catch (e) {

          }
        }
      }
      return badgeBottom;
    },
    judgeMe: function judgeMe () {
        var judgeMeBadge;
        if(this.meta.judgeme !== undefined && this.meta.judgeme.badge !== undefined) {
          judgeMeBadge = this.meta.judgeme.badge;
        }
        return judgeMeBadge;
      },
      judgeMe: function judgeMe () {
        var judgeMeBadge;
        if(this.meta.judgeme !== undefined && this.meta.judgeme.badge !== undefined) {
          judgeMeBadge = this.meta.judgeme.badge;
        }
        return judgeMeBadge;
      }
    };
  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);